'use client';

import type { DownloadButtonProps } from '@/ui-components/molecules/AppDownloadButtons/AppDownloadButtons';
import { AnonymousAlertSnapshotIcon } from './AnonymousAlertSnapshotIcon';
import { AnonymousUserSnapshotIcon } from './AnonymousUserSnapshotIcon';
import { useSnapshotAuth } from './useSnapshotAuth';
import { useSnapshotSubscription } from './useSnapshotSubscription';

interface AccountSnapshotIconsProps {
    appdownloadItem?: DownloadButtonProps[];
}

export function AccountSnapshotIcons({ appdownloadItem }: AccountSnapshotIconsProps): React.JSX.Element {
    const {
        authState,
        isRestoringAuth,
        authenticatedUser,
        teslaManageSelection,
        handleAuthenticated,
        handleSignOut,
    } = useSnapshotAuth();
    const subscriptionState = useSnapshotSubscription(
        authState,
        authenticatedUser?.accountNumber ?? null,
        authenticatedUser?.accountDetailsResponse,
    );

    return (
        <>
            <AnonymousAlertSnapshotIcon
                authState={authState}
                firstName={authenticatedUser?.firstName ?? null}
                isRestoringAuth={isRestoringAuth}
            />
            <AnonymousUserSnapshotIcon
                appdownloadItem={appdownloadItem}
                authenticatedUser={authenticatedUser}
                isRestoringAuth={isRestoringAuth}
                onAuthenticated={handleAuthenticated}
                onSignOut={handleSignOut}
                subscriptionState={subscriptionState}
                teslaManageSelection={teslaManageSelection}
            />
        </>
    );
}
